<template>
  <div>
    <v-row
      v-show="!groupValidated"
      dense
      justify="start"
      class="elevation-1 px-3 mx-1 py-4 my-5 grey lighten-2"
    >
      <v-col cols="12">
        <h3 class="pa-3">{{ $t('conflict.moveOptionsInBoxes') }}:</h3>
      </v-col>
    </v-row>
    <!-- Drop zones -->
    <!-- prefered options drop zone -->
    <v-row
      v-if="!groupValidated"
      @drop="dropHandler($event, 'preferedOptions')"
      @dragover.prevent
      class="elevation-6 px-4 mx-1 py-1 mb-4 mt-n2 white"
      dense
    >
      <v-col cols="12">
        <b>{{ $t('option.favorites') }}:</b>
      </v-col>
      <v-col cols="12">
        <span
          v-for="option in preferedOptions"
          :key="option.id"
          @dragstart="dragStartHandler($event, option, 'preferedOptions')"
          @drag="dragHandler($event)"
          :draggable="!groupValidated"
        >
          <option-chip
            class="rai-draggable__chip"
            :option="option"
          />
        </span>
      </v-col>
    </v-row>
    <!-- Maybe use a optionBlock here ? but we would then need to configure drop handlers in it -->
    <!-- other options blocks -->
    <v-row
      v-for="(blocks, index) in computedOtherOptions"
      :key="index"
      @drop="dropHandler($event, 'otherOptions', index)"
      @dragover.prevent
      class="elevation-6 px-4 mx-1 py-1 mb-4 mt-n2 white"
      dense
    >
      <v-col cols="12">
        <b>{{ $t('option.others') }}:</b>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="removeGroup(index)"
              class="float-right"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="grey">
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('option.removeGroup') }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12">
        <span
          v-for="option in otherOptions[(groupValidated ? currentGroupIndex : index)]"
          :key="option.id"
          @dragstart="dragStartHandler($event, option, 'otherOptions', index)"
          @drag="dragHandler($event)"
          :draggable="!groupValidated"
        >
          <option-chip
            class="rai-draggable__chip"
            :option="option"
          />
        </span>
      </v-col>
    </v-row>
    <!-- add other option group button -->
    <v-row
      v-show="!groupValidated"
      @click="addBlock"
      justify="center"
      align="center"
      class="rai-add-block elevation-0 px-4 mx-1 py-1 mb-4 mt-n2"
      dense
    >
      <v-col cols="1">
        <button>
          <v-icon>mdi-plus</v-icon>
        </button>
      </v-col>
    </v-row>
    <v-row
      justify="center"
    >

      <v-hover
        v-slot:default="{ hover }"
      >
        <v-card
          @click="validateGroupsAndGoToF4_1_04()"
          :elevation="hover ? 12 : 2"
          class="rai-select-option-card ma-2 pa-3"
          outlined
          min-width="220px"
          max-width="22%"
          width="22%"
          :disabled="!groupCompleted"
        >
          <h4 class="text-capitalize text-center primary--text">{{$t('global.yes') }}</h4>
          <br />
          <p class="text-center ">{{ $t('conflict.exclusiveAndUnique') }}</p>
        </v-card>
      </v-hover>

      <v-hover
        v-slot:default="{ hover }"
      >
        <v-card
          @click="validateGroupsAndGoToF4_2_2()"
          :elevation="hover ? 12 : 2"
          class="rai-select-option-card ma-2 pa-3"
          outlined
          min-width="220px"
          max-width="22%"
          width="22%"
          :disabled="!groupCompleted"
        >
          <h4 class="text-capitalize text-center primary--text">{{$t('global.no') }}</h4>
          <br />
          <p class="text-center">{{ $t('conflict.butAddingInfoItCould') }}</p>
        </v-card>
      </v-hover>

    </v-row>

    <v-row justify="center">
      <raison-button
        :button-label="$t('global.finish')"
        :button-function="finish"
        :loading="buttonFinishLoading"
        :disabled="buttonFinishLoading"
      >
        <template v-slot:append>
          <v-icon right>mdi-arrow-right</v-icon>
        </template>
      </raison-button>
    </v-row>

    <v-row>
      <option-groups 
        :scenario="currentScenario"
        v-on="$listeners"
      />
    </v-row>
  </div>
</template>

<script>
import OptionGroups from '@/components/conflictResolution/OptionGroups.vue';
import OptionChip from '@/components/global/OptionChip.vue';
import RaisonButton from '@/components/global/RaisonButton.vue';
import scenarioService from '@/services/scenarios.js';
import groupService from '@/services/groups.js';

export default {
  name: 'Option3Workflow',

  components: { RaisonButton, OptionChip, OptionGroups },

  data () {
    return {
      preferedOptions: [],
      otherOptions: [[]],
      groupValidated: false,
      currentGroupIndex: 0,
      othersOpts : [],
      buttonFinishLoading: false,
      groups: [],
    };
  },

  props: {
    availableOptions: {
      type: Array,
      required: true,
    },
    currentScenario: {
      type: Object,
      required: true,
    },
    preferenceList: {
      type: Array,
      required: true,
    }
  },

  computed: {
    // return preferences related to the selected scenario
    scenarioPreferences() {
      const scenarioPreferences = this.preferenceList
        .filter(pref => pref.scenario.id === this.currentScenario.id);
      console.log('scenarioPreferences', scenarioPreferences, this.currentScenario.id);
      return scenarioPreferences;
    },

    groupCompleted() {
      return this.remainingOptions.length === 0 
        && !this.groupValidated 
        && this.preferedOptions.length !== 0
        && !this.otherOptions.some(group => group.length === 0);
    },

    currentGroupId() {
      if(this.groupCompleted) {
        let groupId = groupService.getGroupId(this.groups, [this.preferedOptions, ...this.otherOptions])
        if(groupId === null) {
          groupId = '$grp2'
        }
        this.$emit('groupSelected', groupId);
        return groupId
      }
      return undefined
    },

    remainingOptions () {
      let remainingOptions = [...this.availableOptions];

      this.preferedOptions.forEach(opt => {
        let res = remainingOptions.find(option => option.id === opt.id);
        if (res) {
          const idx = remainingOptions.indexOf(res);
          remainingOptions.splice(idx, 1);
        }
      });
      this.otherOptions.forEach(elt => {
        elt.forEach(opt => {
          let res = remainingOptions.find(option => option.id === opt.id);
          if (res) {
            const idx = remainingOptions.indexOf(res);
            remainingOptions.splice(idx, 1);
          }
        });
      });
      return remainingOptions;
    },

    computedOtherOptions () {
      if (!this.groupValidated) {
        return this.otherOptions;
      }
      return [this.otherOptions[this.currentGroupIndex]];
    },

    projectId() {
      return this.$route.params.id;
    }
  },

  methods: {
    removeGroup(index) {
      // console.log('remove group ', index);
      this.otherOptions[index].forEach(opt => {
        this.$emit('restoreOption', opt);
      });
      this.otherOptions.splice(index, 1);
    },

    finish() {
      this.$emit("nextTodo"); 
    },

    addBlock () {
      this.otherOptions.push([]);
    },

    dropHandler (e, zone, index) {
      // console.log('dropHandler', e, zone, index, e.dataTransfer.getData('id'));
      const optionId = e.dataTransfer.getData('id');
      if (optionId === '' && optionId === undefined && optionId === 'undefined') {
        throw 'Missing option';
      }
      e.preventDefault();

      const option = this.availableOptions.find(opt => opt.id === optionId); 

      const comeFrom = e.dataTransfer.getData('comeFrom');

      // remove from previous list
      if (comeFrom === 'otherOptions') {
        const index = e.dataTransfer.getData('index');
        this[comeFrom][index].splice(this[comeFrom][index].findIndex(opt => opt.id===optionId), 1);
      } else if (comeFrom === 'preferedOptions') {
        this[comeFrom].splice(this[comeFrom].findIndex(opt => opt.id===optionId), 1);
      }

      // add to new list
      if (zone === 'otherOptions') {
        this[zone][index].push(option);
      } else {
        this[zone].push(option);
      }
      this.$nextTick(() => {
        this.$emit('possibleOptions', this.remainingOptions);
      });
    },

    validateGroups(nextStepFunction) {
      const wigo = this.preferedOptions.map(opt => { return { id: opt.id }});

      const newScenario = {
        ...this.currentScenario,
        name: 'created in workflow 3',
        level: this.currentScenario.level+1,
        id: '$ref1',
      };

      const preferences = this.otherOptions.map(logo => {
        let wigoOrLogos = [...logo.map(opt => opt.id), ...this.preferedOptions.map(opt => opt.id)];
        const previousPreferences = this.scenarioPreferences
          .filter(pref => wigoOrLogos.includes(...pref.wigo.map(opt => opt.id)))
          .map(pref => pref.id);

        return {
          name: 'created in workflow 3: $grp1',
          groupId: '$grp1',
          wigo: wigo,
          logo: logo.map(opt => { return { id: opt.id }}),
          scenario: newScenario,
          previousPreferences: previousPreferences,
        };
      });

      scenarioService.createPreferences(this.projectId, preferences)
        .then(responses => {
          const preferences = responses.data;
          preferences.forEach(preference => {
            this.$emit('addPreferenceToList', preference);
          })
          nextStepFunction(preferences);
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err]});
        })
        .finally(() => {
          this.$emit('addTodo', {
            scenario: { ...this.currentScenario },
            todo: 'extends false'
          });
          this.$emit('nextTodo');
        });

    },

    validateGroupsAndGoToF4_1_04 () {
      this.$emit('addTodo', {
        todo: 'f_43_00',
        scenario: this.currentScenario,
      });
      const f4_1_04 = (preferences) => {
        preferences.forEach(pref => {
          console.log('addTodo: case4.3 f_4.1_04(P)', pref);
          //  f_4.1_04(P)
          this.$emit('addTodo', {'preference': pref, 'todo': 'f_4.1_04(P)'});
        });
      };
      this.validateGroups(f4_1_04);
    },

    validateGroupsAndGoToF4_2_2 () {
        this.$emit('addTodo', {
          todo: 'f_43_00',
          scenario: this.currentScenario,
        });
        console.log('validateGroupsAndGoToF4_2_2: groupId', this.currentGroupId);
        this.$emit("addTodo", {
          scenario: this.currentScenario,
          todo: "f_4.2_02(S)",
          preferedOptions : this.preferedOptions,
          availableGroups: [this.preferedOptions, ...this.otherOptions],
          from : 'case3',
          currentGroupId: this.currentGroupId, // TODO qvdk compute a grouping signature
          otherOptions : this.otherOptions
        });
        this.$emit("nextTodo");
        console.log('gotToF4_2_2')
    },

    dragStartHandler (e, option, comeFrom, index = -1) {
      e.dataTransfer.setData('id', option.id); // NB : not setting dataTransfer breaks draggable in firefox
      e.dataTransfer.setData('comeFrom', comeFrom);
      e.dataTransfer.setData('index', index);
    },

    dragHandler (e) {
      if (e.screenY < 150) {
        window.scrollBy(0, -15)
      } else if ((window.outerHeight - e.screenY) < 80) {
        window.scrollBy(0, 15)
      }
    },

    loadGroups(scenario) {
      this.buttonFinishLoading = true;
      const projectId = this.$route.params.id;
      scenarioService.getOptionGroups(projectId, scenario.id)
        .then((response) => {
          this.groups = response.data;
        })
        .catch(error => {
          this.$emit('raison-event', { type: 'error', messages: [error] });
        })
        .finally(()=> {
          this.buttonFinishLoading = false;
        });
    },
  },

  created() {
    this.loadGroups(this.currentScenario);
  }
};
</script>

<style>
.rai-add-block {
  cursor: pointer;
  border: 2px grey dashed;
}

.rai-select-option-card {
  cursor: pointer;
}
</style>
